import configDB from "../../../../Config/ThemeConfig";

const primary = localStorage.getItem("default_color") || configDB.data.color.primary_color;
const secondary = localStorage.getItem("secondary_color") || configDB.data.color.secondary_color;

export const Currentlysale = {
  series: [
    {
      name: "revenue1",
      data: [2, 15, 25, 20, 30, 26, 24, 15, 12, 20],
    },
    {
      name: "revenue2",
      data: [10, 25, 15, 16, 10, 14, 28, 18, 20, 16],
    },
  ],
  options: {
    chart: {
      height: 168,
      opacity: 1,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [3, 3],
      curve: "smooth",
    },
    xaxis: {
      offsetX: 0,
      offsetY: 0,
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
      labels: {
        low: 0,
        offsetX: 0,
        show: false,
      },
      axisBorder: {
        low: 0,
        offsetX: 0,
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },

    yaxis: {
      show: false,
    },
    grid: {
      show: false,
    },
    colors: [secondary, primary],
    fill: {
      opacity: [0.5, 0.25, 1],
    },

    legend: {
      show: false,
    },
    tooltip: {
      x: {
        format: "MM",
      },
    },
  },
};
export const apexDonutCharts = {
  series: [0, 0],
  options: {
    chart: {
      type: "donut",
      height: 300,
    },
    labels: ["Recommended by Friend", "Social Media"],
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return `${val.toFixed(0)}%`;
      },
      style: {
        fontSize: "12px",
        fontWeight: "bold",
        colors: ["#fff"]
      },
      dropShadow: {
        enabled: false
      },
    },
    legend: {
      show: true,
      position: "bottom",
      labels: {
        useSeriesColors: true,
        formatter: function (seriesName, opts) {
          return seriesName + " : " + opts.w.config.series[opts.seriesIndex];
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
        }, 
      },
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return value;
        },
      },
    },
    colors: [primary, secondary],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          dataLabels: {
            style: {
              fontSize: "10px",
            },
          },
        },
        breakpoint: 360,
        options: {
          chart: {
            height: 280,
          },
        },
      },
    ],
  },
};
export const attendanceChartData = (series, dayLabels, colors, filteredCourseNames) => {
  const categories = dayLabels.flatMap(day =>
    filteredCourseNames.map(courseName => `${day}\n${courseName}`)
  );

  return {
    options: {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: { show: true },
      },
      xaxis: {
        categories: categories,
        title: { text: "Date" },
        labels: {
          formatter: function (value) {
            return typeof value === 'string' && value ? value.split('\n')[1] || '' : '';
          },
          style: {
            fontSize: '10px',
          },
          // rotate: -45,
          // rotateAlways: true,
          trim: true,
          hideOverlappingLabels: false,
        },
        tickAmount: dayLabels.length,
        group: {
          groups: dayLabels.map(day => ({
            title: day,
            cols: filteredCourseNames.length,
          })),
          style: {
            fontSize: '12px',
            fontWeight: 400,
          },
        },
      },
      yaxis: {
        title: { text: "Attendance Count" },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
        offsetY: 0,
        itemMargin: {
          horizontal: 10,
          vertical: 2,
        },
        markers: {
          width: 12,
          height: 12,
        },
        onItemClick: {
          toggleDataSeries: true,
        },
      },
      colors: colors,
      tooltip: {
        zIndex: 1000,
        y: {
          formatter: (val, { seriesIndex, dataPointIndex, w }) => {
            if (val === null) return 'No data';
            const courseIndex = dataPointIndex % filteredCourseNames.length;
            const courseName = filteredCourseNames[courseIndex];
            const status = w.config.series[seriesIndex].name;
            return `${courseName}: ${val} students (${status.toLowerCase()})`;
          },
        },
      },
      plotOptions: {
        bar: {
          columnWidth: '50%',
          borderRadius: 4,
          borderRadiusApplication: 'end',
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => (val !== null && val > 0 ? val : ''),
        style: {
          fontSize: '12px',
          colors: ['#fff'],
        },
      },
    },
    series: series,
  };
};
export const getQuizResultsChartConfig = (data, categories, categoryStats) => {
  return {
    series: [{ name: 'Average Score', data }],
    options: {
      chart: {
        type: 'bar',
        height: 300,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          columnWidth: '50%',
        },
      },
      dataLabels: {
        enabled: true,
        formatter: val => `${val}%`,
      },
      xaxis: {
        categories,
        title: { text: 'Quiz Category' },
        max: 100,
      },
      legend: {
        position: "top",
        formatter: function () {
          return 'Average Score';
        }
      },
      colors: ['#9B8AFB'],
      tooltip: {
        enabled: false,
        y: {
          formatter: function (_, { dataPointIndex }) {
            const cat = categories[dataPointIndex];
            const stat = categoryStats[cat];
            if (!stat?.count) return '';

            const avg = (stat.totalScore / stat.count).toFixed(2);
            return `${avg} marks (${stat.count} attempts)`;
          }
        }
      }
    },
  };
};
export const areachart = {
  series: [
    {
      type: "area",
      name: "Daily",
      data: [0, 20, 10, 45, 30, 43, 25, 38, 30, 42, 25, 40, 25, 0],
      color: "#f0f1fe",
    },
    {
      type: "area",
      name: "Weekly",
      data: [0, 12, 6, 25, 13, 24, 15, 24, 20, 26, 16, 22, 16, 0],
      color:primary,
    },
    {
      type: "line",
      name: "Monthly",
      data: [0, 19, 14, 22, 35, 30, 35, 30, 40, 30, 39, 20, 34, 0],
      color:primary,
    },
  ],
  options: {
    chart: {
      height: 280,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: [0, 0, 5],
      curve: "smooth",
    },
    annotations: {
      xaxis: [
        {
          x: 300,
          strokeDashArray: 0,
          borderWidth: 3,
          borderColor:primary,
        },
      ],
      points: [
        {
          x: 300,
          y: 49,
          marker: {
            size: 8,
            fillColor: primary,
            strokeColor: primary,
            radius: 5,
        },
          label: {
            borderWidth: 0,
            offsetY: 0,
            text: "We are Achieve Our Goal in Progress",
            style: {
              fontSize: "14px",
              fontWeight: "600",
            },
          },
        },
      ],
    },
    responsive: [{
      breakpoint: 767,
      options: {
        chart: {
          height: 250
        },
      },
      breakpoint: 575,
      options: {
        chart: {
          height: 220
        },
        annotations: {
          xaxis: [{
              x: 100,
              strokeDashArray: 0,
              borderWidth: 3,
              borderColor: primary,
            },
          ],
          points: [{
              x: 100,
              y: 48,
              marker: {
                  size: 8,
                  fillColor: primary,
                  strokeColor: primary,
                  radius: 5,
              },
              label: {
                borderWidth: 0,
                offsetX: 25,
                text: 'We are Achieve Our Goal in Progress',
                style: {
                  fontSize: '14px',
                  fontWeight: '600',
                }
            }
          }],
        },
      }
    }],
    fill: {
      type: ["solid", "gradient", "gradient"],
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 1,
        gradientToColors: [primary, primary],
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 0.2,
        stops: [0, 100, 100, 100],
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      offsetX: 0,
      offsetY: 0,
      categories: ["11-09-2023", "12-09-2023", "13-09-2023", "14-09-2023", "15-09-2023", "16-09-2023", "17-09-2023", "18-09-2023", "19-09-2023", "20-09-2023", "21-09-2023", "22-09-2023", "23-09-2023", "24-09-2023"],
      axisBorder: {
        low: 0,
        offsetX: 0,
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        low: 0,
        offsetX: 0,
        show: false,
      },
    },
    tooltip: {
      x: {
        format: "dd/MM/yy",
      },
    },
    yaxis: {
      show: false,
      lines: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
    },
    legend: {
      show: false,
    },
  },
};